// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    label: "Blood Grouping",
    value: "bloodGrouping",
  },
  {
    label: "Serology",
    value: "serology",
  },
];
